module.exports = __webpack_public_path__ + "static/apulanta1-c2bba519be236a982d31ad9c1ace40c4.jpg";